import type {BaseFilterKeys} from '@igp/shared/api';
import type {DateRangeFilterValue, MultiKeyFilterTextValue} from '@igp/shared/components/filter';
import type {RepaymentLog, Timestamp} from '@igp/shared/contract/pam';
import type {Path, SortKeys} from '@igp/shared/utils';

export type RepaymentLogQueryFields = Path<RepaymentLog>;
export type RepaymentLogDownloadFields = Path<RepaymentLog>;
export type RepaymentLogSortKeys = SortKeys<RepaymentLog>;

export type RepaymentLogViewModel = {
    repaymentId: string;
    repaymentDate?: Timestamp;
    masterAgentUid?: string;
    masterAgentUsername?: string;
    fromAgentUid?: string;
    fromAgentUsername?: string;
    repaymentAmount?: number;
};

export type RepaymentLogViewModelKeys = keyof RepaymentLogViewModel;

export type RepaymentLogColumns =
    | 'repaymentDate'
    | 'masterAgentUid'
    | 'masterAgentUsername'
    | 'fromAgentUid'
    | 'fromAgentUsername'
    | 'repaymentAmount'
    | 'edit'
    | 'remove';

export type RepaymentLogTextFilterKeys = keyof Pick<RepaymentLog, 'from_agent_uid' | 'master_agent_uid'>;

export type RepaymentLogFilterKeys = BaseFilterKeys | RepaymentLogTextFilterKeys | 'repayment_date.from' | 'repayment_date.to';

export type RepaymentLogFilterName = 'masterAgentUid_agentUid' | 'repaymentDate';

export type RepaymentLogFilterModel = {
    text: MultiKeyFilterTextValue<RepaymentLogTextFilterKeys>;
    repaymentDate: DateRangeFilterValue;
};

export type RepaymentLogDownloadModel = Record<RepaymentLogViewModelKeys, string>;

export type CreateRepaymentLogPayload = {
    repaymentDate: Timestamp;
    masterAgentUid: string;
    fromAgentUid: string;
    repaymentAmount: number;
};

export type EditRepaymentLogPayload = {
    repaymentId: string;
} & CreateRepaymentLogPayload;

export const RepaymentLogServiceTypes = {
    service: Symbol('RepaymentLogService'),
    downloadClientStrategy: Symbol('RepaymentLogDownloadClientStrategy'),
    downloadServerStrategy: Symbol('RepaymentLogDownloadServerStrategy'),
    epicsBuilder: Symbol('RepaymentLogEpicsBuilder'),
} as const;

export type RepaymentLogErrorCodes = 'PLAYER_IS_NOT_MASTER_AGENT' | 'AGENT_IS_NOT_DOWNLINE_OF_MASTER_AGENT' | 'REPAYMENT_LOG_NOT_FOUND';
